import React from 'react'
import { Carousel, CarouselItem, CarouselIndicators, CarouselCaption } from 'reactstrap'
/* import { FaAngleRight, FaAngleDown } from 'react-icons/fa' */
import CustomModal from './customModal'
import PropTypes from 'prop-types'
import moment from 'moment'
import PRTLogo from '../../assets/img/prayon.technologies.72DPI.400px.png'

export default class NewsCarousel extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeIndex: 0,
            collapse: false,
            showImage: {
                show: false,
                imgUrl: '/'
            }
        }
    }

    onExiting = () => {
        this.animating = true;
    }

    onExited = () => {
        this.animating = false;
    }

    next = () => {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === this.props.news.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({ activeIndex: nextIndex });
    }

    previous = () => {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === 0 ? this.props.news.length - 1 : this.state.activeIndex - 1;
        this.setState({ activeIndex: nextIndex });
    }

    goToIndex = (newIndex) => {
        if (this.animating) return;
        this.setState({ activeIndex: newIndex });
    }

    slides = () => {
        try {
            /** Définition d'un item slide */
            const items = this.props.news.map((item) => {
                let itemTitle = item.Title
                if (itemTitle.length > 23) {
                    itemTitle = `${itemTitle.substring(0, 23)}...`
                }
                return (
                    <CarouselItem
                        className="news-carousel"
                        onExiting={this.onExiting}
                        onExited={this.onExited}
                        key={item.GUID}
                    >
                        <img src={item.Image ? item.Image.Url : PRTLogo} alt={item.Image ? item.Image.Description : ''} />
                        <CarouselCaption className="news-carousel-caption" captionText="" captionHeader={itemTitle} />
                    </CarouselItem>
                )
            })
            return items
        } catch (e) {

        }
    }

    /** Déroule la liste des news */
    collapseNews = () => {
        this.setState({ collapse: !this.state.collapse })
    }

    listItems = () => {
        try {
            /** Définition d'un item slide */
            const items = this.props.news.map((item) => {
                return (
                    <ul key={item.GUID} className="news-list">
                        <li>
                            <h4 className="news-title"><b>{item.Title}</b></h4>
                        </li>
                        <li className="news-content">
                            <div className="news-img-container">
                                <img
                                    className="news-list-img"
                                    src={item.Image ? item.Image.Url : PRTLogo}
                                    alt={item.Image ? item.Image.Description : ''} />
                            </div>
                            <ul className="content-text">
                                <li>
                                    <h5 className="content-date"><b>{moment(item.Created).format('dddd Do MMMM YYYY')}</b></h5>
                                </li>
                                <li>
                                    {item.Contenu.split('\n').map((line, i) =>
                                        (
                                            <p key={i}>{line}</p>
                                        )
                                    )}
                                </li>
                            </ul>
                        </li>
                    </ul>
                )
            })
            return items
        } catch (e) {

        }
    }

    render() {
        return (
            <div>
                {this.props.news && this.props.news.length > 0 ?
                    <Carousel
                        className="carousel-container"
                        activeIndex={this.state.activeIndex}
                        next={this.next}
                        previous={this.previous}
                        interval={2500}>
                        <CarouselIndicators items={this.props.news} activeIndex={this.state.activeIndex} onClickHandler={this.goToIndex} />
                        {this.slides()}
                    </Carousel>
                    :
                    <React.Fragment>
                        <h4>No news to display</h4>
                        <p>Check out if you are <b>online</b></p>
                    </React.Fragment>
                }

                {/* <div className="collapser">
                    <div className="col-1">
                        {this.state.collapse ?
                            <FaAngleDown className="icon clickable" onClick={this.collapseNews} /> :
                            <FaAngleRight className="icon clickable" onClick={this.collapseNews} />}
                    </div>
                    <div className="col-10 text-center">
                        <h5>News details</h5>
                    </div>
                </div> */}
                {/** MODAL */}
                <CustomModal className="news-modal" toggle={this.props.toggleModal} isOpen={this.props.modal} title='News details'>
                    <div className="news-list-container">
                        {this.listItems()}
                    </div>
                </CustomModal>
                {/*                 <Collapse isOpen={this.state.collapse}>
                    <div className="news-list-wrapper">
                        {this.listItems()}
                    </div>
                </Collapse> */}
            </div>
        )
    }
}
NewsCarousel.propTypes = {
    news: PropTypes.arrayOf(PropTypes.shape({
        GUID: PropTypes.string,
        Title: PropTypes.string,
        Contenu: PropTypes.string,
        Created: PropTypes.string,
        Image: PropTypes.shape({
            Description: PropTypes.string,
            Url: PropTypes.string
        })
    })),
    toggleModal: PropTypes.func,
    modal: PropTypes.bool
}
